<template>
  <div class="air-resistance-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F_drag = 1/2 ρv² C_d A$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Sky and altitude markers -->
          <line v-for="i in 5" :key="i" x1="300" :y1="i*40" x2="350" :y2="i*40" stroke="rgba(255,255,255,0.1)" />
          
          <!-- Falling Object -->
          <g :transform="`translate(200, ${posY % 200 + 20})`">
             <!-- The Object -->
             <circle r="10" :fill="massColor" stroke="#fff" />
             <!-- Force Vectors -->
             <line x1="0" y1="0" x2="0" y2="40" stroke="#ff4757" stroke-width="2" /> <!-- Gravity -->
             <text x="5" y="45" fill="#ff4757" font-size="8">G</text>

             <line x1="0" y1="0" x2="0" :y2="-dragForce*2" stroke="#00d2ff" stroke-width="2" v-if="velocity > 0" /> <!-- Drag -->
             <text x="5" :y="-dragForce*2 - 5" fill="#00d2ff" font-size="8" v-if="velocity > 0">F_f</text>
          </g>

          <!-- Velocity Gauge -->
          <rect x="20" y="40" width="10" height="160" fill="#111" />
          <rect x="20" :y="200 - velocity*4" width="10" :height="velocity*4" fill="#2ed573" />
          <text x="5" y="35" fill="#888" font-size="8">速度 v</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>当前速度: {{ velocity.toFixed(1) }} m/s</label>
              <div class="value" v-if="Math.abs(velocity - terminalV) < 0.5">到达收尾速度！</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>物体质量 m</label>
             <el-slider v-model="mass" :min="1" :max="10" size="mini"></el-slider>
          </div>
          <div class="row">
             <label>阻力系数 (降落伞模式)</label>
             <el-switch v-model="hasParachute"></el-switch>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>在流体（如空气）中下落时，物体的阻力随速度增加而增大。当阻力增加到与重力相等时，合力为零，物体开始做**匀速直线运动**。这一恒定速度称为**收尾速度**。减小质量或增大迎风面积（如撑开降落伞）会显著降低收尾速度。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AirResistanceViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      mass: 5,
      hasParachute: false,
      velocity: 0,
      posY: 0,
      timer: null
    }
  },
  computed: {
    dragCoeff() { return this.hasParachute ? 1.5 : 0.2; },
    terminalV() { return Math.sqrt((this.mass * 9.8) / this.dragCoeff) * 2; },
    dragForce() { return 0.5 * this.dragCoeff * this.velocity * this.velocity; },
    massColor() { return this.hasParachute ? '#1e90ff' : '#aaaaaa'; }
  },
  methods: {
    update() {
      // a = (mg - drag) / m
      let accel = (this.mass * 0.1 - this.dragForce * 0.05) / this.mass;
      this.velocity += accel;
      if (this.velocity < 0) this.velocity = 0;
      this.posY += this.velocity * 0.5;
      this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.air-resistance-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
